import {InjectionToken, Provider} from '@angular/core';

export const TISA_ICONS_PATH = new InjectionToken<string>(
  'Provides path to icons folder.',
);

export const TISA_ICON_PROVIDERS: Provider[] = [
  {
    provide: TISA_ICONS_PATH,
    useValue: '/assets/tisa-icons',
  },
];
